export default __webpack_public_path__ + "static/media/Girdle of the First Circle.dc2cd599.jpg";